import React from 'react'
import { FormattedMessage } from 'react-intl'

// import ArrowLeftIcon from 'assets/icons/arrow-left'
// import ArrowRightIcon from 'assets/icons/arrow-right'

import {
  ReportsTabWrapper,
  ReportsTabItem
  //Divider
  // FilterTabSliderContainer,
  // FilterTabsContainer,
  // TabsArrowIconWrapper, FiltersTabsOpacityRight
} from '../style'


export const ReportsHeaderTabs = ({ changeTab, active }) => {
  // const [position, setPosition] = useState('left')
  //
  // const handleMoveSlider = (e) => {
  //   setPosition(e)
  // }

  return (
    <ReportsTabWrapper onClick={changeTab} data-test='tabs'>
      {/*<ReportsTabItem isActive={active === 'predefined'} disabled={active !== 'predefined'} id='predefined'>*/}
      {/*  <FormattedMessage id='predefined' />*/}
      {/*</ReportsTabItem>*/}
      {/*<Divider height='16px' margin='0 16px' />*/}
      {/*<TabsArrowIconWrapper disabled={position === 'left'} onClick={() => {*/}
      {/*  handleMoveSlider('left')*/}
      {/*}}>*/}
      {/*  <ArrowLeftIcon />*/}
      {/*</TabsArrowIconWrapper>*/}
      {/*<FilterTabSliderContainer>*/}
      {/*  <FilterTabsContainer position={position}>*/}
      {/*    <ReportsTabItem isActive={active === 'speciesAtSite'} disabled={active === 'predefined'} id='speciesAtSite'>*/}
      {/*      <FormattedMessage id='speciesAtSite' />*/}
      {/*    </ReportsTabItem>*/}
      {/*    <ReportsTabItem isActive={active === 'ecosystemsAtSite'} disabled={active === 'predefined'}*/}
      {/*      id='ecosystemsAtSite'>*/}
      {/*      <FormattedMessage id='ecosystemsAtSite' />*/}
      {/*    </ReportsTabItem>*/}
      {/*    <ReportsTabItem isActive={active === 'siteDetails'} disabled={active === 'predefined'} id='siteDetails'>*/}
      {/*      <FormattedMessage id='siteDetails' />*/}
      {/*    </ReportsTabItem>*/}
      {/*    <ReportsTabItem isActive={active === 'threats'} disabled={active === 'predefined'} id='threats'>*/}
      {/*      <FormattedMessage id='threats' />*/}
      {/*    </ReportsTabItem>*/}
      {/*    <ReportsTabItem isActive={active === 'actions'} disabled={active === 'predefined'} id='actions'>*/}
      {/*      <FormattedMessage id='actions' />*/}
      {/*    </ReportsTabItem>*/}
      {/*    <ReportsTabItem isActive={active === 'usersAndAssessment'} disabled={active === 'predefined'}*/}
      {/*      id='usersAndAssessment'>*/}
      {/*      <FormattedMessage id='usersAndAssessment' />*/}
      {/*    </ReportsTabItem>*/}
      {/*    <ReportsTabItem isActive={active === 'speciesGlobal'} disabled={active === 'predefined'} id='speciesGlobal'>*/}
      {/*      <FormattedMessage id='speciesGlobal' />*/}
      {/*    </ReportsTabItem>*/}
      {/*  </FilterTabsContainer>*/}
      {/*  <FiltersTabsOpacityRight position={position} />*/}
      {/*</FilterTabSliderContainer>*/}
      {/*<TabsArrowIconWrapper disabled={position === 'right'} onClick={() => {*/}
      {/*  handleMoveSlider('right')*/}
      {/*}}>*/}
      {/*  <ArrowRightIcon />*/}
      {/*</TabsArrowIconWrapper>*/}
      <>
        <ReportsTabItem isActive={active === 'siteDetails'} disabled={active === 'predefined'} id='siteDetails'>
          <FormattedMessage id='siteDetails' />
        </ReportsTabItem>
        <ReportsTabItem isActive={active === 'speciesAtSite'} disabled={active === 'predefined'} id='speciesAtSite'>
          <FormattedMessage id='speciesAtSite' />
        </ReportsTabItem>
        <ReportsTabItem isActive={active === 'monitoringSites'} disabled={active === 'predefined'} id='monitoringSites'>
          <FormattedMessage id='monitoringSites' />
        </ReportsTabItem>
      </>
    </ReportsTabWrapper>
  )
}

export default ReportsHeaderTabs
